(function($) {
    $(function () {
        $('[data-selector-id="main-nav"] a').each(function () {
            var $href = $(this).attr('href');
            var $lenindex = window.location.href.length - window.location.href.indexOf($href);
            //since Blog was added to the menu, have to do extra checking
            if ($href !== undefined && window.location.href.indexOf($href) > 0 && $href !== '/') {
                if ($href === '/blog' && window.location.href.length - window.location.href.indexOf($href) === 5) {
                    //then we're on the blog page
                    $(this).addClass('blog-active');
                    return false;
                }
                if ($href !== '/blog') {
                    $(this).addClass('blog-active');
                    return false;
                }                
            }
        });
    });
})($JQ);

(function ($) {
    $(function () {
        var wordsPerMinute = 200; // Average case.

        $('.blog-article-read-time').each(function (e) {
            var text = $('.blog-article-body').text();

            var result;

            var textLength = text.split(' ').length; // Split by words
            if (textLength > 0) {
                var value = Math.ceil(textLength / wordsPerMinute);
                result = '~' + value;
            }
            $('.estimated-read-time').text(result);
        });
    });
})($JQ);